import { createSelector } from 'reselect';

const formatData = (data) => {
    if (data.results) {
        const formattedProducts = [];
        for (let i = 0; i < data.results.length; i += 1) {
            const product = data.results[i];
            formattedProducts.push({
                companyID: product.company_id,
                userID:    product.user_id,
                companyName: product.company_name,
                companyType: product.company_type,
                organizerBooth: product.organizer_booth,
                name: product.name,
                mediaType: product.media_type,
                mediaDuration: product.media_duration,
                companyShortName: product.company_short_name,
                zoneId: product.zone_id,
                zoneName: product.zone_name,
                media: product.media,
                outputThumb: product.output_thumb_filepath,
            });
        }
        const formattedData = {
            page: data.page,
            size: data.page_size,
            totalProduct: data.total_length,
            totalPage: data.total_page,
            results: formattedProducts,
        };
        return formattedData;
    }
    return { results: [] };
};

const OrganizerList = {
    createAllProdcuts4CategorySelector: ()=>createSelector([
        (state) => state.organizerList.getProducts.listProduct,
    ], (data) => formatData(data)),
    createProductsSelector: () => createSelector([
        (state) => state.organizerList.getProducts.listProduct,
    ], (data) => formatData(data)),
    createProductListSmallZoneSelector: () => createSelector([
        (state) => state.organizerList.getSmallBooth.data,
    ], (data) => formatData(data)),
    createProductListStandardZoneSelector: () => createSelector([
        (state) => state.organizerList.getStandardBooth.data,
    ], (data) => formatData(data)),
    createProductListBigZoneSelector: () => createSelector([
        (state) => state.organizerList.getBigBooth.data,
    ], (data) => formatData(data)),
    createProductListGrandZoneSelector: () => createSelector([
        (state) => state.organizerList.getGrandBooth.data,
    ], (data) => formatData(data)),
};
export default OrganizerList;
